import React from 'react';
import { Modal } from 'react-bootstrap';
import {
    ModalH1,
    ModalH2,
    ModalButton,
  } from '../ModalElements';
import { trackClick } from '../../../../utils/api';

const PengkinianDataModal = ({ show, onLogin }) => {
  return (
    <Modal show={show} centered>
      <Modal.Header closeButton={false} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <ModalH1><b>Pengkinian Data</b></ModalH1>
      </Modal.Header>
      <Modal.Body>
        <ModalH2>Silakan melakukan pembaruan data untuk meningkatkan kenyamanan dan keamanan dalam bertransaksi.</ModalH2>
      </Modal.Body>
      <Modal.Footer style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <ModalButton variant="primary" onClick={() => { onLogin(); trackClick("Pengkinian Data"); }}>
          Perbarui Sekarang!
        </ModalButton>
      </Modal.Footer>
    </Modal>
  );
};

export default PengkinianDataModal;
